module.exports = __webpack_public_path__ + "02_bob_grey.758c7157.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/02_bob_grey.png
// module id = z6Jh
// module chunks = 0